import React from "react";
import { Col, Typography, Form, Row } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import SystemPermissionsToggles from "../../SystemPermissionsToggles";

export const PermissionsForm = ({ form, onFinish, permissions }) => {
  return (
    <Form form={form} onFinish={onFinish}>
      <SystemPermissionsToggles permissions={permissions} />
      <Row justify="start">
        <Col>
          <InfoCircleOutlined style={{ marginRight: "5px" }} />
          <Typography.Text>
            Ao habilitar o acesso, o funcionário terá permissão de usuário
            padrão, sem permissões adicionais. Para fornecer mais permissões,
            acesse a área de administração do sistema em questão.
          </Typography.Text>
        </Col>
      </Row>
    </Form>
  );
};
